//react
import React, { Component } from 'react';

//content
import HcpAbout from '../../content/hcp/about/about';
import HcpPrescribingInformation from '../../content/hcp/prescribingInformation/prescribingInformation';
import HcpTrainingMaterials from '../../content/hcp/trainingMaterials/trainingMaterials';
import HcpUsingNyxoidVideo from '../../content/hcp/usingNyxoidVideo/usingNyxoidVideo';
import PublicAbout from '../../content/public/about/about';
import PublicPatientInformationCard from '../../content/public/patientInformationCard/patientInformationCard';
import PublicUsingNyxoidVideo from '../../content/public/usingNyxoidVideo/usingNyxoidVideo';

//legal content
import ContactUs from '../../content/legal/contactUs';
import CookiePolicy from '../../content/legal/cookiePolicy';
import PrivacyPolicy from '../../content/legal/privacyPolicy';
import ReportASideEffect from '../../content/legal/reportASideEffect';
import TermsOfUse from '../../content/legal/termsOfUse';
import LegalInformation from '../../content/legal/legalInformation';

class PageRequestContent extends Component {
	render() {
		const culture = this.props.culture;
		const section = this.props.section;
		const page = this.props.page;

		if (culture === 'terms-of-use' || section === 'terms-of-use' || page === 'terms-of-use') {
			return <TermsOfUse culture={culture} />
		} else if (culture === 'privacy-policy' || section === 'privacy-policy' || page === 'privacy-policy') {
			return <PrivacyPolicy culture={culture} />
		} else if (culture === 'cookie-policy' || section === 'cookie-policy' || page === 'cookie-policy') {
			return <CookiePolicy culture={culture} />
		} else if (culture === 'report-a-side-effect' || section === 'report-a-side-effect' || page === 'report-a-side-effect') {
			return <ReportASideEffect culture={culture} section={section} />
		} else if (culture === 'contact-us' || section === 'contact-us' || page === 'contact-us') {
			return <ContactUs culture={culture} />
		} else if (culture === 'legal-information' || section === 'legal-information' || page === 'legal-information') {
			return <LegalInformation culture={culture} />
		}

		const getPage = () => {
			switch (section) {
				case 'hcp':
					switch (page) {
						case 'about':
							return <HcpAbout culture={culture} />
						case 'prescribing-information':
							return <HcpPrescribingInformation culture={culture} />
						case 'training-materials':
							return <HcpTrainingMaterials culture={culture} />
						case 'using-nyxoid-video':
							return <HcpUsingNyxoidVideo culture={culture} />
						default:
							return null
					}
				case 'public':
					switch (page) {
						case 'about':
							return <PublicAbout culture={culture} />
						case 'patient-information-card':
							return <PublicPatientInformationCard culture={culture} />
						case 'using-nyxoid-video':
							return <PublicUsingNyxoidVideo culture={culture} />
						default:
							return null
					}
				default:
					return null
			}
		}

		return getPage();
	}
}

export default PageRequestContent;



// WEBPACK FOOTER //
// ./src/components/pageRequestContent/pageRequestContent.js